
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/shared/Icon.vue';
import Modal from '@/components/shared/Modal.vue';

@Component<WarningModal>({
	components: {
		Modal,
		Icon
	}
})
export default class WarningModal extends Vue {
	@Prop({ type: Boolean, required: true }) private show!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private closeOnClickOutside!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private hideCloseButton!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private showCheckbox!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private confirmLoading!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private cancelLoading!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private preserveLineBreaks!: boolean;
	@Prop({ type: String, required: false }) private title!: string;
	@Prop({ type: String, required: true }) private message!: string;
	@Prop({ type: String, required: false }) private confirmButtonText!: string;
	@Prop({ type: String, required: false }) private cancelButtonText!: string;
	@Prop({ type: String, required: false, default: '' }) private checkboxLabel!: string;
	@Prop({ type: String, required: false, default: 'default' }) private confirmButtonStyle!: 'default' | 'inverse';
	@Prop({ type: String, required: false, default: 'error' }) private type!: 'success' | 'info' | 'warning' | 'error';

	private get modalIcon(): string {
		switch (this.type) {
			case 'success':
				return 'check-circle-outline';
			case 'info':
			case 'warning':
				return 'alert-circle-outline';
			default:
				return 'close-circle-outline';
		}
	}

	/**
	 * Split the message on its line breaks so each line can be spaced on its own
	 *
	 * @return {string[]}
	 */
	private get messageLines(): string[] {
		return this.message.split('\n');
	}

	private get isProfileRoute(): boolean {
		return this.$route.path.includes('profile');
	}

	private get loading(): boolean {
		return this.confirmLoading || this.cancelLoading;
	}

	private created() {
		document.documentElement.classList.add('modal-open');
	}

	private beforeDestroy() {
		document.documentElement.classList.remove('modal-open');
	}
}
